import { render, staticRenderFns } from "./NewConference.vue?vue&type=template&id=f300a23a&"
import script from "./NewConference.vue?vue&type=script&lang=js&"
export * from "./NewConference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports